import React from 'react';
import PropTypes from 'prop-types';
import Swiper from '@deporvillage/swiper-component';
import Picture from '@deporvillage/picture-component';

import styles from './Thumbnails.module.scss';

const Thumbnails = ({ collection, size = 75, onClick, onHover }) => {
    
    const elem = React.useRef(null);
    const [arrows, setArrows] = React.useState('none');

    React.useEffect(() => {
        const containerHeight = elem?.current.getBoundingClientRect()?.height;
        const wrapperHeight = collection?.length * (size + 20); // 20 is the margin between slides
        setArrows(containerHeight < wrapperHeight ? 'out' : 'none');
    }, [collection, size]);

    return (
        <div className={styles['thumbnails-component']} ref={elem}>
            <Swiper
                vertical
                multiple
                arrows={arrows}
            >
                {
                    collection.map((i, idx) => (
                        <div
                            key={`Picture${idx}`}
                            className={styles['slide']}
                            data-testid={`product-gallery-miniature`}
                            onClick={() => onClick && onClick(idx)}
                            onMouseOver={() => onHover && onHover(idx)}
                        >
                            <Picture
                                name={`Picture${idx}`}
                                src={`product/${i}`}
                                lazy
                                width={size}
                                height={size}
                            />
                        </div>
                    ))
                }
            </Swiper>
        </div>
    );
};
Thumbnails.propTypes = {
    collection: PropTypes.array,
    size: PropTypes.number,
    onClick: PropTypes.func,
    onHover: PropTypes.func,
};

export default Thumbnails;
